import usa  from './countries/usa';
import uk from './countries/uk';
import virginia from './usa/virginia/virginia';
import virginiaDBHDS from './usa/virginia-dbhds/virginia';

export const countries: {[key: string]: {data: any, type: string}} = {
  usa: { data: usa, type: 'json' },
  uk: { data: uk, type: 'json' },
  virginia: {data: virginia, type: 'json'},
  'virginia-dbhds': {data: virginiaDBHDS, type: 'json'}
};

export const specialAreas = {
  usa: {
    Alaska: {
      left: -131,
      top: 25,
      width: 15
    },
    Hawaii: {
      left: -110,
      top: 28,
      width: 5
    },
    'Puerto Rico': {
      left: -76,
      top: 26,
      width: 2
    }
  }
};

export const countryOptions = Object.keys(countries).map(x => {
  if (x === 'uk' || x === 'usa' || x === 'virginia') {
    return [x, x.toUpperCase()];
  }
  if (x === 'italy_regions') {
    return [x, 'Italy (regions)'];
  }
  if (x === 'virginia-dbhds') {
    return [x, 'Virginia (DBHDS)'];
  }
  return [x, x[0].toUpperCase() + x.slice(1)];
});


// // Types
// type Ring = number[][];
// type PolygonCoords = Ring[];
// type MultiPolygonCoords = PolygonCoords[];
// type Geometry = { type: 'Polygon' | 'MultiPolygon'; coordinates: PolygonCoords | MultiPolygonCoords };
// type Feature = { properties: { name: string }; geometry: Geometry };
// type CountryData = { data: { features: Feature[] } };

// type RegionNode = {
//   name: string;
//   geometry: Geometry;
//   centroid: number[];
//   parent?: RegionNode;
//   children: RegionNode[];
// };

// type CentroidMap = { [key: string]: { value: number[] } };
// const centroidForEachCountry: { [key: string]: CentroidMap } = {};


// const calculateArea = (ring: Ring): number => {
//   let s = 0;
//   for (let i = 0; i < ring.length - 1; i++) {
//     s += ring[i][0] * ring[i + 1][1] - ring[i + 1][0] * ring[i][1];
//   }
//   return 0.5 * s;
// };

// const centroidOfOuterRing = (outerRing: Ring): number[] => {
//   let cx = 0, cy = 0;
//   for (let i = 0; i < outerRing.length - 1; i++) {
//     const [x0, y0] = outerRing[i];
//     const [x1, y1] = outerRing[i + 1];
//     const cross = x0 * y1 - x1 * y0;
//     cx += (x0 + x1) * cross;
//     cy += (y0 + y1) * cross;
//   }
//   const a = calculateArea(outerRing);
//   const factor = 1 / (6 * a);
//   return [cx * factor, cy * factor];
// };

// const calculateCentroidPolygon = (poly: PolygonCoords): number[] => {
//   const outer = poly[0];
//   const outerArea = Math.abs(calculateArea(outer));
//   const outerCentroid = centroidOfOuterRing(outer);

//   let cx = outerCentroid[0] * outerArea;
//   let cy = outerCentroid[1] * outerArea;
//   let totalArea = outerArea;

//   for (let h = 1; h < poly.length; h++) {
//     const hole = poly[h];
//     const holeArea = Math.abs(calculateArea(hole));
//     const holeCentroid = centroidOfOuterRing(hole);
//     cx -= holeCentroid[0] * holeArea;
//     cy -= holeCentroid[1] * holeArea;
//     totalArea -= holeArea;
//   }

//   return [cx / totalArea, cy / totalArea];
// };

// const calculateCentroidMulti = (multi: MultiPolygonCoords): number[] => {
//   let cx = 0, cy = 0, totalArea = 0;
//   for (const poly of multi) {
//     const outer = poly[0];
//     const outerArea = Math.abs(calculateArea(outer));
//     const outerCentroid = centroidOfOuterRing(outer);

//     let areaNet = outerArea;
//     let cxPoly = outerCentroid[0] * outerArea;
//     let cyPoly = outerCentroid[1] * outerArea;

//     for (let h = 1; h < poly.length; h++) {
//       const hole = poly[h];
//       const holeArea = Math.abs(calculateArea(hole));
//       const holeCentroid = centroidOfOuterRing(hole);
//       cxPoly -= holeCentroid[0] * holeArea;
//       cyPoly -= holeCentroid[1] * holeArea;
//       areaNet -= holeArea;
//     }

//     cx += cxPoly;
//     cy += cyPoly;
//     totalArea += areaNet;
//   }
//   return [cx / totalArea, cy / totalArea];
// };

// const pointInRing = (point: number[], ring: Ring): boolean => {
//   const [x, y] = point;
//   let inside = false;
//   for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
//     const [xi, yi] = ring[i];
//     const [xj, yj] = ring[j];
//     const intersect = (yi > y) !== (yj > y) && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
//     if (intersect) inside = !inside;
//   }
//   return inside;
// };

// const pointInPolygon = (point: number[], geometry: Geometry): boolean => {
//   if (geometry.type === 'Polygon') {
//     const rings = geometry.coordinates as PolygonCoords;
//     if (!pointInRing(point, rings[0])) return false;
//     for (let h = 1; h < rings.length; h++) {
//       if (pointInRing(point, rings[h])) return false;
//     }
//     return true;
//   } else {
//     const polys = geometry.coordinates as MultiPolygonCoords;
//     for (const poly of polys) {
//       if (!pointInRing(point, poly[0])) continue;
//       let inHole = false;
//       for (let h = 1; h < poly.length; h++) {
//         if (pointInRing(point, poly[h])) { inHole = true; break; }
//       }
//       if (!inHole) return true;
//     }
//     return false;
//   }
// };

// const avgOfOuter = (geometry: Geometry): number[] => {
//   const outer = geometry.type === 'Polygon'
//     ? (geometry.coordinates as PolygonCoords)[0]
//     : (geometry.coordinates as MultiPolygonCoords)[0][0];
//   const sum = outer.reduce((acc, p) => [acc[0] + p[0], acc[1] + p[1]], [0, 0]);
//   return [sum[0] / outer.length, sum[1] / outer.length];
// };


// const adjustCentroidIfOut = (geometry: Geometry, centroid: number[]): number[] => {
//   if (pointInPolygon(centroid, geometry)) return centroid;
//   const target = avgOfOuter(geometry);
//   let c = centroid.slice();
//   for (let k = 0; k < 24; k++) {
//     c = [c[0] * 0.65 + target[0] * 0.35, c[1] * 0.65 + target[1] * 0.35];
//     if (pointInPolygon(c, geometry)) break;
//   }
//   return c;
// };

// const pushOutOfChild = (parent: Geometry, child: Geometry, point: number[]): number[] => {
//   if (!pointInPolygon(point, child)) return point;
//   const target = avgOfOuter(parent);
//   let p = point.slice();
//   for (let k = 0; k < 32; k++) {
//     p = [p[0] * 0.6 + target[0] * 0.4, p[1] * 0.6 + target[1] * 0.4];
//     if (!pointInPolygon(p, child) && pointInPolygon(p, parent)) break;
//   }
//   return p;
// };

// // ---------------- Hierarchy ----------------
// const buildHierarchy = (nodes: RegionNode[]): RegionNode[] => {
//   const areaOfGeom = (g: Geometry): number => {
//     if (g.type === 'Polygon') return Math.abs(calculateArea((g.coordinates as PolygonCoords)[0]));
//     const polys = g.coordinates as MultiPolygonCoords;
//     return polys.reduce((sum, poly) => sum + Math.abs(calculateArea(poly[0])), 0);
//   };

//   const sorted = nodes.slice().sort((a, b) => areaOfGeom(b.geometry) - areaOfGeom(a.geometry));

//   for (const child of sorted) {
//     if (child.name.endsWith("city")) { 
//       continue; // independent cities should not be nested under counties 
//     }
//     let candidateParent: RegionNode | undefined;
//     for (const maybeParent of sorted) {
//       if (maybeParent === child) continue;
//       if (pointInPolygon(child.centroid, maybeParent.geometry)) {
//         if (!candidateParent || areaOfGeom(maybeParent.geometry) < areaOfGeom(candidateParent.geometry)) {
//           candidateParent = maybeParent;
//         }
//       }
//     }
//     if (candidateParent) {
//       child.parent = candidateParent;
//       candidateParent.children.push(child);
//     }
//   }
//   return sorted.filter(n => !n.parent);
// };

// const adjustHierarchyCentroids = (root: RegionNode): void => {
//   for (const child of root.children) adjustHierarchyCentroids(child);
//   root.centroid = adjustCentroidIfOut(root.geometry, root.centroid);
//   for (const child of root.children) {
//     root.centroid = pushOutOfChild(root.geometry, child.geometry, root.centroid);
//   }
// };


// Object.keys(countries).forEach((country) => {
//   const { data } = countries[country];

  
//   const nodes = data.features.map((f) => { 
//     const g = f.geometry; const name = f.properties?.name?.toLowerCase() || 'unknown'; let centroid = g.type === 'Polygon' ? calculateCentroidPolygon(g.coordinates) : calculateCentroidMulti(g.coordinates); // ✅ Special-case adjustment for Richmond City & Henrico County 
//     if (name === "richmond city") { centroid = adjustCentroidIfOut(g, avgOfOuter(g)); centroid = [centroid[0] + 0.05, centroid[1] + 0.05]; // nudge east/north 
//     } 
//     if (name === "henrico county") { centroid = adjustCentroidIfOut(g, avgOfOuter(g)); centroid = [centroid[0] - 0.05, centroid[1] - 0.05]; // nudge west/south 
//     } 
//     return { name, geometry: g, centroid, children: [], }; });

  
//   for (const n of nodes) {
//     n.centroid = adjustCentroidIfOut(n.geometry, n.centroid);
//   }

  
//   const roots = buildHierarchy(nodes);
//   for (const r of roots) adjustHierarchyCentroids(r);

  
//   const centroidData: CentroidMap = {};
//   nodes.forEach((n) => {
//     const key = n.name.toLowerCase().trim();
//     centroidData[key] = { value: n.centroid };
//   });
//   centroidForEachCountry[country] = centroidData;
// });

const centroidForEachCountry = {
  "york county": [
    37.233000000000004,
    -76.54841666666667
  ],
  "wythe county": [
    36.917,
    -81.0585
  ],
  "wise county": [
    37.0015,
    -82.58850000000001
  ],
  "winchester city": [
    39.1645,
    -78.1753359375
  ],
  "williamsburg city": [
    37.278999999999996,
    -76.70777380952381
  ],
  "westmoreland county": [
    38.1225,
    -76.7935
  ],
  "waynesboro city": [
    38.0655,
    -78.90632572115385
  ],
  "washington county": [
    36.7555,
    -81.96171854304636
  ],
  "warren county": [
    38.8975,
    -78.197
  ],
  "virginia beach city": [
    36.7395,
    -76.03252327028372
  ],
  "tazewell county": [
    37.134,
    -81.566
  ],
  "sussex county": [
    36.897,
    -77.31602636447734
  ],
  "surry county": [
    37.090500000000006,
    -76.89195588235295
  ],
  "suffolk city": [
    36.738,
    -76.61677173913043
  ],
  "staunton city": [
    38.159000000000006,
    -79.062
  ],
  "stafford county": [
    38.4165,
    -77.46000000000001
  ],
  "spotsylvania county": [
    38.1815,
    -77.66245131372949
  ],
  "southampton county": [
    36.769999999999996,
    -77.09866666666667
  ],
  "smyth county": [
    36.834,
    -81.51958333333334
  ],
  "shenandoah county": [
    38.852999999999994,
    -78.582
  ],
  "scott county": [
    36.741,
    -82.58502586206896
  ],
  "salem city": [
    37.288,
    -80.0665
  ],
  "russell county": [
    36.92700000000001,
    -82.093
  ],
  "rockingham county": [
    38.5325,
    -78.9382962962963
  ],
  "rockbridge county": [
    37.8115,
    -79.413
  ],
  "roanoke county": [
    37.266,
    -80.15029198266521
  ],
  "roanoke city": [
    37.275,
    -79.9585
  ],
  "richmond county": [
    37.957499999999996,
    -76.73792105263158
  ],
  "richmond city": [
    37.521,
    -77.45871949602122
  ],
  "rappahannock county": [
    38.692499999999995,
    -78.13499999999999
  ],
  "radford city": [
    37.121,
    -80.56594117647059
  ],
  "pulaski county": [
    37.063,
    -80.724
  ],
  "prince william county": [
    38.7225,
    -77.44434692307692
  ],
  "prince george county": [
    37.138,
    -77.26162295081967
  ],
  "prince edward county": [
    37.227500000000006,
    -78.46488571428571
  ],
  "powhatan county": [
    37.554500000000004,
    -77.894
  ],
  "portsmouth city": [
    36.822,
    -76.34225776397516
  ],
  "poquoson city": [
    37.138999999999996,
    -76.3495
  ],
  "pittsylvania county": [
    36.837500000000006,
    -79.40350000000001
  ],
  "petersburg city": [
    37.2055,
    -77.392
  ],
  "patrick county": [
    36.707,
    -80.27428787878787
  ],
  "page county": [
    38.6255,
    -78.48237867647057
  ],
  "orange county": [
    38.256,
    -77.99529117774881
  ],
  "nottoway county": [
    37.1325,
    -78.07042857142858
  ],
  "norton city": [
    36.9295,
    -82.63696875000001
  ],
  "northumberland county": [
    37.8595,
    -76.45977777777779
  ],
  "northampton county": [
    37.339,
    -75.94606666666667
  ],
  "norfolk city": [
    36.8945,
    -76.23212253289473
  ],
  "newport news city": [
    37.091,
    -76.49125925925927
  ],
  "new kent county": [
    37.5045,
    -76.99926071428571
  ],
  "nelson county": [
    37.7905,
    -78.90057432432432
  ],
  "montgomery county": [
    37.1675,
    -80.37185227272727
  ],
  "middlesex county": [
    37.6435,
    -76.6358724137931
  ],
  "mecklenburg county": [
    36.717,
    -78.3835
  ],
  "mathews county": [
    37.419,
    -76.29478225806452
  ],
  "martinsville city": [
    36.68,
    -79.8675
  ],
  "manassas park city": [
    38.7765,
    -77.45109090909091
  ],
  "manassas city": [
    38.7445,
    -77.48523
  ],
  "madison county": [
    38.4355,
    -78.27931666666666
  ],
  "lynchburg city": [
    37.400999999999996,
    -79.1765
  ],
  "lunenburg county": [
    36.9525,
    -78.24643643859218
  ],
  "louisa county": [
    37.9435,
    -77.93488454545455
  ],
  "loudoun county": [
    39.0895,
    -77.662953125
  ],
  "lexington city": [
    37.785,
    -79.44131
  ],
  "lee county": [
    36.7445,
    -82.98346354166667
  ],
  "lancaster county": [
    37.7245,
    -76.53534722222221
  ],
  "king and queen county": [
    37.704499999999996,
    -76.86123596491228
  ],
  "king william county": [
    37.718,
    -77.12122307692309
  ],
  "king george county": [
    38.278000000000006,
    -77.17080392156862
  ],
  "james city county": [
    37.318,
    -76.80105
  ],
  "isle of wight county": [
    36.893,
    -76.70750000000001
  ],
  "hopewell city": [
    37.287499999999994,
    -77.2955
  ],
  "highland county": [
    38.385999999999996,
    -79.5565
  ],
  "henry county": [
    36.695,
    -79.98866129032257
  ],
  "henrico county": [
    37.533,
    -77.30387586206896
  ],
  "harrisonburg city": [
    38.4385,
    -78.87014204545454
  ],
  "hanover county": [
    37.7645,
    -77.55939227272728
  ],
  "hampton city": [
    37.054500000000004,
    -76.40304135338346
  ],
  "halifax county": [
    36.8035,
    -78.91600529865124
  ],
  "greensville county": [
    36.7195,
    -77.56532777777778
  ],
  "greene county": [
    38.3315,
    -78.48400000000001
  ],
  "grayson county": [
    36.6815,
    -81.23646964285714
  ],
  "goochland county": [
    37.7405,
    -77.98114285714286
  ],
  "gloucester county": [
    37.4265,
    -76.5678552631579
  ],
  "giles county": [
    37.313,
    -80.67362499999999
  ],
  "galax city": [
    36.662,
    -80.92551344086021
  ],
  "fredericksburg city": [
    38.298500000000004,
    -77.48849999999999
  ],
  "frederick county": [
    39.2385,
    -78.2865
  ],
  "franklin county": [
    37.0035,
    -79.86994047619048
  ],
  "franklin city": [
    36.679,
    -76.9385
  ],
  "fluvanna county": [
    37.8485,
    -78.2765
  ],
  "floyd county": [
    36.919,
    -80.37100000000001
  ],
  "fauquier county": [
    38.716499999999996,
    -77.81798305084746
  ],
  "falls church city": [
    38.8845,
    -77.172
  ],
  "fairfax county": [
    38.838499999999996,
    -77.41334375
  ],
  "fairfax city": [
    38.8515,
    -77.3015
  ],
  "essex county": [
    37.945499999999996,
    -76.9691875
  ],
  "emporia city": [
    36.695,
    -77.53649999999999
  ],
  "dinwiddie county": [
    37.075,
    -77.649
  ],
  "dickenson county": [
    37.1315,
    -82.344
  ],
  "danville city": [
    36.591499999999996,
    -79.4115
  ],
  "cumberland county": [
    37.5465,
    -78.21223860777187
  ],
  "culpeper county": [
    38.507999999999996,
    -78.00145505617976
  ],
  "craig county": [
    37.488,
    -80.19035
  ],
  "covington city": [
    37.782,
    -79.98949999999999
  ],
  "colonial heights city": [
    37.263999999999996,
    -77.39500000000001
  ],
  "clarke county": [
    39.123000000000005,
    -77.991
  ],
  "chesterfield county": [
    37.3905,
    -77.62935858585858
  ],
  "chesapeake city": [
    36.707,
    -76.27584903381643
  ],
  "charlottesville city": [
    38.039500000000004,
    -78.488
  ],
  "charlotte county": [
    36.973,
    -78.60669652406418
  ],
  "charles city county": [
    37.366,
    -77.07882352941176
  ],
  "carroll county": [
    36.7445,
    -80.75049999999999
  ],
  "caroline county": [
    38.0135,
    -77.358
  ],
  "campbell county": [
    37.2245,
    -79.10022711864407
  ],
  "buena vista city": [
    37.7295,
    -79.35901043557169
  ],
  "buckingham county": [
    37.563500000000005,
    -78.5435
  ],
  "buchanan county": [
    37.2885,
    -82.06045
  ],
  "brunswick county": [
    36.782,
    -77.8535
  ],
  "bristol city": [
    36.6175,
    -82.15962386877828
  ],
  "botetourt county": [
    37.5555,
    -79.793
  ],
  "bland county": [
    37.126999999999995,
    -81.15899999999999
  ],
  "bedford county": [
    37.314,
    -79.5215
  ],
  "bath county": [
    38.0535,
    -79.74600000000001
  ],
  "augusta county": [
    38.1845,
    -79.30133988095238
  ],
  "arlington county": [
    38.8805,
    -77.102
  ],
  "appomattox county": [
    37.378,
    -78.80699999999999
  ],
  "amherst county": [
    37.602500000000006,
    -79.15350000000001
  ],
  "amelia county": [
    37.3425,
    -78.043
  ],
  "alleghany county": [
    37.781,
    -80.11131447963801
  ],
  "alexandria city": [
    38.8155,
    -77.0915
  ],
  "albemarle county": [
    37.951499999999996,
    -78.56853228155339
  ],
  "accomack county": [
    37.747,
    -75.69721794871793
  ]
}
export default centroidForEachCountry;
